import { call } from 'redux-saga/effects';

let initModule = null;
export function* initPurchaseBaf({ payload }) {
  if (!initModule) {
    initModule = yield call(() => import('./init'));
  }
  // llamada a modulo
  yield call(initModule.initPurchaseBaf, { payload });
}
let setInfoModule = null;
export function* setInfoBaf({ payload }) {
  if (!setInfoModule) {
    setInfoModule = yield call(() => import('./set-info'));
  }
  // llamada a modulo
  yield call(setInfoModule.setInfoBaf, { payload });
}
let checkOutModule = null;
export function* checkoutBaf({ payload }) {
  if (!checkOutModule) {
    checkOutModule = yield call(() => import('./checkout'));
  }
  // llamada a modulo
  yield call(checkOutModule.checkoutBaf, { payload });
}
let processOrderModule = null;
export function* processOrderBaf() {
  if (!processOrderModule) {
    processOrderModule = yield call(() => import('./process-order'));
  }
  // llamada a modulo
  yield call(processOrderModule.processOrderBaf, {});
}
let sendPurchaseOtpModule = null;
export function* sendPurchaseOtpBaf({ payload }) {
  if (!sendPurchaseOtpModule) {
    sendPurchaseOtpModule = yield call(() => import('./send-purchase-otp'));
  }
  // llamada a modulo
  yield call(sendPurchaseOtpModule.sendPurchaseOtpBaf, {
    payload,
  });
}
let validatePurchaseOtpModule = null;
export function* validatePurchaseOtpBaf({ payload }) {
  if (!validatePurchaseOtpModule) {
    validatePurchaseOtpModule = yield call(() =>
      import('./validate-purchase-otp')
    );
  }
  // llamada a modulo
  yield call(validatePurchaseOtpModule.validatePurchaseOtpBaf, {
    payload,
  });
}
